import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import { UpwardTransition } from 'src/utils';
import { setPasswordChangeSuccess } from '../actions/login';
import { IMessage, showMessage } from '../actions/message';
import MessageDialog from '../components/MessageDialog';
import Progress from '../components/Progress';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import * as scenario from '../scenario/login';
const styles = (theme: Theme) =>
	createStyles({
		form: {
			margin: 'auto',
			maxWidth: 700,
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(4),
		},
		title: {
			fontSize: 14,
			marginBottom: 16,
		},
	});

// tslint:disable-next-line:no-empty-interface
interface IRouteParams {}

interface IRouteState
	extends Pick<IState, 'companyCode' | 'loginID' | 'managerChk'> {}
interface IState {
	companyCode: string;
	changedPassword: string;
	isShowConfirmLogout?: boolean;
	loginID: string;
	reInputPassword: string;
	managerChk: string;
}

/**
 * パスワード変更画面
 */
class ChangePassword extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			changedPassword: '',
			companyCode: '',
			loginID: '',
			managerChk: '',
			reInputPassword: '',
		};

		this.handleChange = this.handleChange.bind(this);
		this.changePassword = this.changePassword.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.logout = this.logout.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.handleCloseConfirmLogout = this.handleCloseConfirmLogout.bind(
			this
		);
		this.handleDialogClose = this.handleDialogClose.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		if (!this.props.location || !this.props.location.state) {
			return;
		}

		const state = this.props.location.state;
		const { companyCode, loginID, managerChk } = state;
		this.setState({
			companyCode,
			loginID,
			managerChk,
		});
	}

	public render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				<Progress open={this.props.isShowProgress} />
				<Paper>
					<div className={classes.form}>
						<div>
							<Typography>
								{i18n.t('ChangePassword_0001')}
							</Typography>
						</div>
						<form noValidate={true} autoComplete="off">
							<Grid
								container={true}
								spacing={2}
								direction="column"
								justify="center"
							>
								<Grid item={true}>
									<TextField
										type="text"
										name="loginId"
										label={i18n.t('ChangePassword_0002')}
										value={this.state.loginID}
										disabled={true}
									/>
								</Grid>
								<Grid item={true}>
									<TextField
										type="password"
										name="changedPassword"
										label={i18n.t('ChangePassword_0003')}
										value={this.state.changedPassword}
										onChange={this.handleChange}
										onKeyPress={this.handleKeyPress}
									/>
								</Grid>
								<Grid item={true}>
									<TextField
										type="password"
										name="reInputPassword"
										label={i18n.t('ChangePassword_0004')}
										value={this.state.reInputPassword}
										onChange={this.handleChange}
										onKeyPress={this.handleKeyPress}
									/>
								</Grid>
								<Grid item={true}>
									<Grid
										container={true}
										spacing={3}
										justify="space-between"
									>
										<Grid item={true} xs={true}>
											<Button
												variant="contained"
												color="primary"
												onClick={this.changePassword}
											>
												{i18n.t('ChangePassword_0005')}
											</Button>
										</Grid>
										<Grid item={true} xs={true}>
											<Button
												variant="contained"
												onClick={this.logout}
											>
												{i18n.t('ChangePassword_0006')}
											</Button>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</form>
					</div>
				</Paper>
				<MessageDialog
					open={this.props.message.open}
					contents={this.props.message.messages}
					title={this.props.message.title}
					showCancelButton={false}
					onClickOk={this.handleDialogClose}
					onClose={this.handleDialogClose}
					messageNs="loginmessage"
				/>
				<Dialog
					open={this.state.isShowConfirmLogout ? true : false}
					TransitionComponent={UpwardTransition}
					keepMounted={true}
					onClose={this.handleCloseConfirmLogout}
					aria-labelledby="alert-dialog-slide-title"
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('ChangePassword_0007')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('ChangePassword_0008')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleLogout} color="primary">
							{i18n.t('ChangePassword_0009')}
						</Button>
						<Button onClick={this.handleCloseConfirmLogout}>
							{i18n.t('ChangePassword_0010')}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}

	/**
	 * パスワード変更ハンドラ
	 * @param event
	 */
	protected handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		const { name, value } = event.target;
		const state = {};
		state[name] = value;
		this.setState(state);
	}

	/**
	 * パスワード変更実行
	 * @param event
	 */
	protected changePassword(event?: React.MouseEvent<HTMLElement>) {
		const { changedPassword, reInputPassword } = this.state;
		const messages: IMessage[] = [];
		if (!changedPassword && reInputPassword) {
			// 両方入力されていない
			messages.push({
				content: 'COM_E_0005',
				replacements: [i18n.t('ChangePassword_0011')],
			});
		} else {
			if (!changedPassword) {
				// 変更後パスワードのみ入力されていない
				messages.push({
					content: 'COM_E_0005',
					replacements: [i18n.t('ChangePassword_0012')],
				});
			} else if (!reInputPassword) {
				// 変更後パスワード再入力のみ入力されていない
				messages.push({
					content: 'COM_E_0005',
					replacements: [i18n.t('ChangePassword_0013')],
				});
			}

			if (changedPassword.length > 256) {
				// 最大桁数チェック
				messages.push({
					content: 'COM_E_0006',
					replacements: [i18n.t('ChangePassword_0012'), '256'],
				});
			}
			if (changedPassword !== reInputPassword) {
				// 差異チェック
				messages.push({
					content: 'COM_E_0007',
					replacements: [
						i18n.t('ChangePassword_0012'),
						i18n.t('ChangePassword_0013'),
					],
				});
			}
		}

		if (messages.length > 0) {
			this.props.showMessage(messages);
			return;
		}

		this.props.changePassword(this.state.changedPassword);
	}

	/**
	 * キー押下ハンドラ
	 * @param event
	 */
	protected handleKeyPress(event: React.KeyboardEvent<HTMLDivElement>) {
		if (event.key === 'Enter') {
			this.changePassword();
		}
	}

	/**
	 * ログアウト確認ハンドラ
	 * @param event
	 */
	protected logout(event: React.MouseEvent<HTMLElement>) {
		this.setState({ isShowConfirmLogout: true });
	}

	/**
	 * ログアウト実行ハンドラ
	 * @param event
	 */
	protected handleLogout(event: React.MouseEvent<HTMLElement>) {
		this.props.logout();
	}

	/**
	 * 確認ダイアログクローズハンドラ
	 * @param event
	 */
	protected handleCloseConfirmLogout(event: React.MouseEvent<HTMLElement>) {
		this.setState({ isShowConfirmLogout: false });
	}

	/**
	 * メッセージクローズハンドラ
	 */
	protected handleDialogClose() {
		this.props.showMessage([]);
		if (this.props.loginState.passwordChangeSuccess) {
			// successフラグを元に戻してログイン処理
			this.props.setPasswordChangeSuccess(false);
			this.props.loginAfterChangePassword(
				this.state.loginID,
				this.state.managerChk
			);
		}
	}
}

const mapStateToProps = (state: IRootState) => ({
	isShowProgress: state.login.isShowProgress,
	loginState: state.login,
	message: state.message,
	profile: state.profile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	changePassword: (password: string) =>
		scenario.changePassword(dispatch, password),
	loginAfterChangePassword: (loginID: string, managerChk: string) =>
		scenario.loginAfterChangePassword(dispatch, loginID, managerChk),
	logout: () => scenario.logout(dispatch),
	setPasswordChangeSuccess: (passwordChangeSuccess: boolean) =>
		dispatch(setPasswordChangeSuccess({ passwordChangeSuccess })),
	showMessage: (messages: IMessage[]) =>
		dispatch(
			showMessage({ messages, title: i18n.t('ChangePassword_0014') })
		),
});

// tslint:disable-next-line: no-empty-interface
export interface IChangePasswordProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IChangePasswordProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ChangePassword);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IChangePasswordProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/ChangePassword.tsx